import { Box,Center,Text } from '@chakra-ui/react'
import IconListItem from './IconListItem'



function ServiceWho () {
    const serviceCoverage = {
        sleepingRough: {
            title: 'YES',
            description: 'Sleeping Rough (for example, on the street or in a car)'
        },
        couchSurfing: {
            title: 'YES',
            description: 'Couch surfing - living temporarily with friends or family due to homelessness'
        },
        roomingHouse: {
            title: 'YES',
            description: 'Living in a boarding house, hostel, or hotel'
        },
        rental: {
            title: 'YES',
            description: 'Living in social housing or private rental accommodation at risk of losing their home and becoming homeless'
        },
        publicHousing: {
            title: 'YES',
            description: 'In public housing where housing security is at risk'
        },
        other: {
            title: 'Unsure?',
            description: 'If you think think you are at risk of homeslessness but don\'t fit into a category above, please call us (02) 8898 6500 for advice.'
        },

    
      }
    return (
      <Center>
        <Box borderWidth={0} p={4} mt={5} mb={2} w={['100%','90%','80%','60%']}>
            <Text fontSize='1rem' fontWeight='600' mb={4}>We offer free legal services to people who are homeless or at risk of becoming homeless. This includes people who are: </Text>
            <IconListItem 
                iconText={serviceCoverage.sleepingRough.title} 
                description={serviceCoverage.sleepingRough.description}
                badgeVariant='solid'
                />
            <IconListItem 
                iconText={serviceCoverage.couchSurfing.title} 
                description={serviceCoverage.couchSurfing.description}
                badgeVariant='solid'            
                />
            <IconListItem 
                iconText={serviceCoverage.roomingHouse.title} 
                description={serviceCoverage.roomingHouse.description}
                badgeVariant='solid'
                />
            <IconListItem 
                iconText={serviceCoverage.rental.title} 
                description={serviceCoverage.rental.description}
                badgeVariant='solid'
                />
            <IconListItem 
                iconText={serviceCoverage.publicHousing.title}
                badgeVariant='solid'
                description={serviceCoverage.publicHousing.description} 
                />
            <IconListItem 
                iconText={serviceCoverage.other.title} 
                description={serviceCoverage.other.description}
                badgeVariant='outline'
                />

        </Box>
        </Center>

    )
}

export default ServiceWho
